var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":{..._vm.data, project_domain: _vm.data.domain, tenant: _vm.data.project },"resource":"meter_instance_caches","base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"hiddenKeys":['status']}})
}
var staticRenderFns = []

export { render, staticRenderFns }